export default __webpack_public_path__ + "static/media/dynamite_explosion.683bc38a.mp3";